module.exports = __webpack_public_path__ + "static/media/worldMap2.b5b42fa6.png";